/**
 * Tap Card SDK v2 — token id extraction.
 *
 * The SDK's `onSuccess(payload)` callback delivers the successful
 * tokenization result in a payload whose top-level shape is NOT stable
 * across card brands and browsers. Observed shapes on Production:
 *   • `{id, object:"token", card:{...}}`                          ← direct
 *   • `{token:{id, object:"token", card:{...}}}`                  ← nested (some Mada/iOS paths)
 *   • `{card:{id:"tok_...", ...}}`                                ← fallback shape
 *
 * Reading only `payload.id` yielded `undefined` on the nested shape,
 * which then caused the backend to reject the request with a Pydantic
 * 422 (`token_id: Field required`), which then crashed the React tree
 * when the array-shaped `detail` was rendered into `<span>{error}</span>`.
 *
 * This helper isolates the extraction into a small pure function so it
 * can be exhaustively unit-tested without a browser or the real SDK.
 */
export function extractTokenId(payload) {
  if (payload == null || typeof payload !== "object") return null;
  const candidate =
    payload.id ||
    (payload.token && payload.token.id) ||
    (payload.card && payload.card.id) ||
    null;
  if (typeof candidate !== "string") return null;
  const trimmed = candidate.trim();
  return trimmed.length > 0 ? trimmed : null;
}
